<template>
  <div id="insuReceipt" style="font-size: 12px;font-family:宋体;width: 300px;" class="receipt">
    <h3 style="text-align: center; font-size: 14px;margin-top: 10px;">{{ printConfig.titleName ||
      $store.state.global.countInfo.hospitalName }}
    </h3>
    <h4 style="text-align: center;font-family:宋体; font-size: 12px;margin: 5px 0;">收费单</h4>
    <div class="header-info" style="padding-bottom: 10px;">
      <div style="font-size: 12px;padding: 0 20px;">姓名：{{ formData.psnName }} {{ formData.gender == 0 ? '女' : '男' }} {{
        formData.age }}{{ formData.ageType }}</div>
      <div style="font-size: 12px;padding: 0 20px;">手机号：{{ formData.phoneNo }}</div>
      <div style="font-size: 12px;padding: 0 20px;">诊号：{{ formData.mdtrtId }}</div>
      <div style="font-size: 12px;padding: 0 20px;">医生：{{ formData.drName }}</div>
      <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
      <!-- 药品 -->
      <div v-if="formData.orderItemDrugList && formData.orderItemDrugList.length > 0">
        <div>
          <div style="font-size: 12px;padding: 0 20px;">药品名称</div>
          <div style="padding-bottom:0px;padding: 0 20px;display: flex;justify-content: space-between">
            <div style="font-size: 12px;">单价</div>
            <div style="font-size: 12px;">数量</div>
            <div style="font-size: 12px;">金额</div>
          </div>
        </div>
        <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
        <div v-for="item in formData.orderItemDrugList" :key="item.id">
          <div style="font-size: 12px;padding: 0 20px;">{{ item.drugName }}</div>
          <div style="padding-bottom:0px;padding: 0 20px;display: flex;justify-content: space-between">
            <div style="font-size: 12px;">{{ handleDecimal(item.salePrice) }}</div>
            <div style="font-size: 12px;">{{ item.dosage }} {{ item.saleUnit }}</div>
            <div style="font-size: 12px;">{{ drugAmt(item.salePrice, item.dosage) }}</div>
          </div>
        </div>
        <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
      </div>
      <!-- 检查治疗项 -->
      <div v-if="formData.orderItemExamList && formData.orderItemExamList.length > 0">
        <div>
          <div style="font-size: 12px;padding: 0 20px;">检查治疗项</div>
          <div style="padding-bottom:0px;padding: 0 20px;display: flex;justify-content: space-between">
            <div style="font-size: 12px;">单价</div>
            <div style="font-size: 12px;">数量</div>
            <div style="font-size: 12px;">金额</div>
          </div>
        </div>
        <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
        <div v-for="item in formData.orderItemExamList" :key="item.id" style="padding: 0 20px;font-size: 12px;">
          <div style="">{{ item.examName }}</div>
          <div style="padding-bottom:0px;display: flex;justify-content: space-between">
            <div style="font-size: 12px;">{{ item.salePrice.toFixed(2) }}</div>
            <div style="font-size: 12px;">{{ item.count }} {{ item.saleUnit }}</div>
            <div style="font-size: 12px;">{{ drugAmt(item.salePrice, item.count) }}</div>
          </div>
        </div>
        <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
      </div>
      <!-- 诊疗项目 -->
      <div v-if="formData.orderItemDiagnosisList && formData.orderItemDiagnosisList.length > 0">
        <div>
          <div style="font-size: 12px;padding: 0 20px;">诊疗项目</div>
          <div style="padding-bottom:0px;padding: 0 20px;display: flex;justify-content: space-between">
            <div style="font-size: 12px;">单价</div>
            <div style="font-size: 12px;">数量</div>
            <div style="font-size: 12px;">金额</div>
          </div>
        </div>
        <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
        <div v-for="item in formData.orderItemDiagnosisList" :key="item.id" style="padding: 0 20px;font-size: 12px;">
          <div style="">{{ item.itemName }}</div>
          <div style="padding-bottom:0px;display: flex;justify-content: space-between">
            <div style="font-size: 12px;">{{ item.salePrice.toFixed(2) }}</div>
            <div style="font-size: 12px;">{{ item.totalNum }} {{ item.saleUnit }}</div>
            <div style="font-size: 12px;">{{ drugAmt(item.salePrice, item.totalNum) }}</div>
          </div>
        </div>
        <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
      </div>
      <div style="font-size: 12px;padding: 0 20px;">合计：{{ formData.medfeeSumamt }}</div>
      <div style="font-size: 12px;padding: 0 20px;">应付：{{ formData.medfeeSumamt }}</div>
      <div style="font-size: 12px;padding: 0 20px;">实付：{{ formData.medfeeSumamt }}</div>
      <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
      <div style="font-size: 12px;padding: 0 20px;">订单号：{{ formData.orderNo }}</div>
      <div style="font-size: 12px;padding: 0 20px;">人员编号：{{ formData.psnNo }}</div>
      <!-- <div style="font-size: 12px;padding-left: 20px;">持卡人：{{ formData.cardholder}}  关系：{{ formData.relationship }} </div> -->
      <div style="font-size: 12px;padding: 0 20px;">医疗类别：{{ formData.medTypeLabel }}</div>
      <div style="font-size: 12px;padding: 0 20px;">医保余额：{{ formData.minsuranceBalance }}</div>
      <div style="font-size: 12px;padding: 0 20px;">原有余额：{{ formData.originalBalance }}</div>
      <div style="font-size: 12px;padding: 0 20px;">起付线：{{ formData.actPayDedc }}</div>
      <div style="font-size: 12px;padding: 0 20px;">基金支付：{{ formData.fundPaySumamt }}</div>
      <div style="font-size: 12px;padding: 0 20px;">共济支付：{{ formData.acctMulaidPay }}</div>
      <div style="font-size: 12px;padding: 0 20px;">账户支付：{{ formData.acctPay }}</div>
      <div style="font-size: 12px;padding: 0 20px;">
        {{ formData.othPayDesc ? formData.othPayDesc : '现金支付' }}：{{ formData.othPay }}
      </div>
      <div class="script" style="border-bottom: 1px dashed #000000;clear:both;margin: 5px 20px;"></div>
      <div style="font-size: 12px;padding: 0 20px;">收费员：{{ formData.tollCollector }}</div>
      <div style="font-size: 12px;padding: 0 20px;">收费时间：{{ formData.setlTime }}</div>
      <div style="font-size: 12px;padding: 0 20px;">打印时间：{{ printTime }}</div>
      <div style="font-size: 16px;margin-top: 5px;text-align: center;">药品离柜，概不退换</div>
    </div>
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js';
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';


const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  name: 'insuReceiptPrint',
  props: {
    settlementObj: {
      type: Object,
      default: {
      },
    },
    isReview: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      printConfig: {
        paperWidth: 80,
        printDetails: '',
        printPatientName: '',
      },
      hospitalName: '',
      chargingTime: '',
      feeTime: '', // 收费时间
      viewScript: {},
      printTime: '',//打印时间
      formData: {},
    }
  },
  methods: {
    print ({ isReview } = {}) {
      this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      const { medicineValue } = this.$store.state.global.printConfig;
      this.$nextTick(() => {
        const LODOP = getLodop();
        LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
        LODOP.PRINT_INIT('医保收费单');
        const pageWith = this.printConfig.paperWidth == 80 ? 790 : 570;
        LODOP.SET_PRINT_PAGESIZE(3, pageWith, '30mm', '小票打印'); // 这里3表示纵向打印且纸高“按内容的高度”；1385表示纸宽138.5mm；45表示页底空白4.5mm
        LODOP.ADD_PRINT_HTM(0, 5, "100%", "100%", document.getElementById("insuReceipt").innerHTML);
        LODOP.SET_PRINTER_INDEX(medicineValue);
        LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
        LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
        LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
        // LODOP.ADD_PRINT_LINE(5,20, 5, 280,2, 0)
        // if (isReview) {
          LODOP.PREVIEW();
        // } else {
        //   LODOP.PRINT();
        // }
        // 关闭打印触发事件
        LODOP.On_Return = (taskId, value) => {
          this.$emit('reviewClose');
        }
      });
    },
    // 计算金额
    drugAmt (price, num) {
      return BN(price).multipliedBy(num).toFixed(2);
    },
    // 获取打印配置
    getPrintConfig () {
      this.$api.clinicManagement.getPrintConfit({ configType: 5 }).then((res) => {
        this.printConfig = res;
      })
    },
    // 处理小数点
    handleDecimal (value) {
      if (!value) return;
      return Number(value).toFixed(2);
    },
  },
  computed: {
    laboratoryName () {
      return this.$store.state.global.countInfo.laboratoryName;
    },
  },
  watch: {
    settlementObj (newa, olda) {
      this.formData = newa;
      // console.log("cs2",this.formData)
    }
  },
  mounted () {
    this.getPrintConfig();
  }
}
</script>
<style lang="scss" scoped>
// .header-info {
//   border-bottom: 2px solid #000000;
// }
.receipt {
  // display: flex;
  width: 300px;
  // justify-content: space-between;
  // padding-left: 20px;
}

span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  background: white;

  left: -5000px;
  top: -500px;
  // left: 1000px;
  // top: 100px;
  z-index: 100;

}
</style>
